/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutNotificationSpec } from './rolloutNotificationSpec';
import { RolloutWaveState } from './rolloutWaveState';


export interface RolloutWaveResponse { 
    /**
     * User friendly name for the wave.
     */
    name?: string;
    /**
     * Internal name for the wave, only visible to operator.
     */
    internal_name?: string;
    /**
     * scheduled execution start time for the wave.
     */
    window_start_time?: Date;
    /**
     * scheduled execution end time for the wave.
     */
    window_end_time?: Date;
    /**
     * List of notifications spec to be created.
     */
    notification_spec?: Array<RolloutNotificationSpec>;
    /**
     * Created user email ID.
     */
    created_by?: string;
    /**
     * Created Date Time
     */
    created_ts?: Date;
    /**
     * Updated user email ID.
     */
    updated_by?: string;
    /**
     * Updated Date Time
     */
    updated_ts?: Date;
    /**
     * Rollout Wave ID.
     */
    id?: string;
    /**
     * Rollout ID.
     */
    rollout_id?: string;
    state?: RolloutWaveState;
}
export namespace RolloutWaveResponse {
}


